import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { STORE_MODULE_NAME } from './const';
import { State as StateType } from './types';

const Organization = namespace(STORE_MODULE_NAME);

@Component
export default class PageOrganizationCardMixin extends Vue {
  // Vuex
  @Organization.State
  organization: StateType['organization'];

  // AsyncData
  async asyncData({ store, route }: any) {
    await store.state[STORE_MODULE_NAME].request;
  }
}



// WEBPACK FOOTER //
// ./src/pages/organizations/card/common.ts